export default "__VITE_ASSET__DewPGyKd__"